import React, { FunctionComponent, useCallback, useContext, useState } from "react"
import { Card, Divider, Grid, IconButton, Typography, useTheme } from "@mui/material"
import { Check, Clear, Settings } from "@mui/icons-material"
import { VehicleToMaterial } from "../../../../../api/graphql/queries/get-vehicle-with-id"
import { TourGenerationContext } from "../../../../../context/tour-generation-context"
import { DayOfWeek } from "../../../../../utils/day"
import { TourGenerationVehicleMaterials } from "../tour-generation-vehicle-materials"
import { ICustomDeparturePoint, ICustomOperatingTime, IVehicleEntry } from "../tour-generation-vehicle-selection"
import { TourGenerationVehicleConfigurationDialog } from "./tour-generation-vehicle-configuration-dialog"
import { TourGenerationVehicleCardDays } from "./tour-generetion-vehicle-card-days"

interface ITourGenerationVehicleCardProps {
  vehicle: IVehicleEntry
  handleChangeSelection: (vehicleId: number) => (days: DayOfWeek[]) => void
  updateMaterials: (vehicle: IVehicleEntry) => (materials: VehicleToMaterial[]) => void
  handleChangeCustomDeparturePoint: (vehicleId: number) => (customDeparturePoin: ICustomDeparturePoint) => void
  handleChangeCustomOperatingTimes: (vehicleId: number) => (customOperatingTimes: ICustomOperatingTime) => void
  handleChangeActive: (vehicleId: number) => () => void
}

export const TourGenerationVehicleCard: FunctionComponent<ITourGenerationVehicleCardProps> = (props) => {
  const theme = useTheme()
  const [configurationOpen, setConfigurationOpen] = useState<boolean>(false)
  const {
    vehicle,
    updateMaterials,
    handleChangeSelection,
    handleChangeCustomDeparturePoint,
    handleChangeCustomOperatingTimes,
    handleChangeActive,
  } = props

  const toggleConfigurationDialog = useCallback(
    () => setConfigurationOpen(!configurationOpen),
    [configurationOpen, setConfigurationOpen],
  )

  const { tourWithoutContainers } = useContext(TourGenerationContext)

  return (
    <>
      <TourGenerationVehicleConfigurationDialog
        open={configurationOpen}
        onClose={toggleConfigurationDialog}
        vehicle={vehicle}
        handleChangeSelection={handleChangeSelection}
        onCustomDeparturePointEntryChange={handleChangeCustomDeparturePoint(vehicle.vehicleId)}
        onCustomOperatingTimeEntryChange={handleChangeCustomOperatingTimes(vehicle.vehicleId)}
        updateMaterials={updateMaterials}
      />
      <Card>
        <Grid container>
          <Grid item>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ width: 30, minHeight: "100%", cursor: "pointer" }}
              style={{
                backgroundColor: vehicle.isActive ? theme.palette.primary.light : theme.palette.grey[300],
              }}
              onClick={handleChangeActive(vehicle.vehicleId)}
            >
              {vehicle.isActive && <Check sx={{ color: "primary.contrastText" }} />}
              {!vehicle.isActive && <Clear sx={{ color: "#000" }} />}
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid container direction="column" sx={{ p: 1 }}>
              <Grid item>
                <Typography sx={{ fontWeight: "bold" }}>{vehicle.licencePlate}</Typography>
              </Grid>
              <Grid item container>
                <Grid item xs>
                  <TourGenerationVehicleCardDays vehicle={vehicle} handleChangeSelection={handleChangeSelection} />
                </Grid>
                {!tourWithoutContainers && (
                  <>
                    <Grid item sx={{ pl: 1, pr: 1 }}>
                      <Divider orientation="vertical" />
                    </Grid>
                    <Grid item xs>
                      <TourGenerationVehicleMaterials
                        notEditable
                        selectedMaterials={vehicle.materials}
                        updateSelectedMaterials={updateMaterials(vehicle)}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <IconButton size="small" onClick={toggleConfigurationDialog}>
              <Settings />
            </IconButton>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}
